/*
 * @message:
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-07-09 11:01:00
 * @FilePath: \mrc-ess-fronted\src\util\htmlToPdf.js
 * @最后编辑: Betway
 * @最后修改时间: 2021-08-26 11:18:58
 */
// 导出页面为PDF格式
import html2Canvas from "html2canvas";
import JsPDF from "jspdf";
import store from "../store"; //狀態管理
export default {
  install(Vue, options) {
    Vue.prototype.getPdf = function() {
      var title = this.$t("label_essweb_RosterRecord_list_title"); //this.htmlTitle;
      html2Canvas(document.querySelector("#pdfDom"), {
        allowTaint: true,
      })
        .then(function(canvas) {
          let contentWidth = canvas.width;
          let contentHeight = canvas.height;
          let pageHeight = (contentWidth / 592.28) * 841.89;
          let leftHeight = contentHeight;
          let position = 0;
          let imgWidth = 595.28;
          let imgHeight = (592.28 / contentWidth) * contentHeight;
          let pageData = canvas.toDataURL("image/jpeg", 1.0);
          let PDF = new JsPDF("", "pt", "a4");
          if (leftHeight < pageHeight) {
            PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
          } else {
            while (leftHeight > 0) {
              PDF.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
              leftHeight -= pageHeight;
              position -= 841.89;
              if (leftHeight > 0) {
                PDF.addPage();
              }
            }
          }
          PDF.save(title + ".pdf");
          store.dispatch("setLoading", false);
        })
        .catch((err) => {
          console.error(err);
          store.dispatch("setLoading", false);
        });
    };
  },
};
